<template>
  <div class="container" v-if="key">
    <div class="web-container" :class="{minus:minus}">
      <div class="title-container">
        <div class="name" v-line-clamp="1">{{name}}</div>
        <div class="btns">
          <div class="item" @click="onMinus">
            <a-icon type="minus-square" />
          </div>
          <div class="item" @click="onStop">
            <a-icon type="close-square" />
          </div>
        </div>
      </div>
      <div class="video-container">
        <video-player
          ref="videoPlayer"
          :options="playerOptions"
          :playsinline="true"
          :style="{width:'100%',height:'100%'}"
        ></video-player>
      </div>
    </div>
    <div class="index-handle" @click="onShow">
      <div class="text">正在播放</div>
    </div>
  </div>
</template>

<script>
import { videoPlayer } from 'vue-video-player'
import 'video.js/dist/video-js.css'
import { mapActions, mapMutations } from 'vuex'
import { setTimeout } from 'timers';
export default {
  components: {
    videoPlayer
  },
  data() {
    return {}
  },
  computed: {
    video() {
      return this.$store.state.demo.video
    },
    name() {
      return this.$store.state.demo.name
    },
    key() {
      return this.$store.state.demo.key
    },
    minus() {
      return this.$store.state.demo.minus
    },
    player() {
      return this.$refs.videoPlayer.player
    },
    playerOptions() {
      return {
        autoplay: true, 
        sources: [
          { 
            src: this.video
          }
        ]
      }
    }
  },
  created() {

  },
  methods: {
    ...mapMutations(['DEMO_SET_MINUS','DEMO_STOP']),
    onMinus() {
      this.DEMO_SET_MINUS(true)
    },
    onShow() {
      this.DEMO_SET_MINUS(false)
    },
    onStop() {
      this.DEMO_STOP()
    }
  }
}
</script>

<style lang="less" scoped>
.web-container {
  position: absolute;
  height: 300px;
  width: 500px;
  background: #1890ff;
  top: 300px;
  right: 0;
  z-index: 1002;
  display: flex;
  flex-direction: column;
  .title-container {
    display: flex;
    flex-direction: row;
    height: 30px;
    line-height: 30px;
    padding: 0 10px;
    .name {
      flex: 1;
      color: #fff;
    }
    .btns {
      display: flex;
      flex-direction: row;
      color: #fff;
      font-size: 20px;
      .item {
        cursor: pointer;
        margin-right: 5px;
      }
    }
  }
  .video-container {
    width: 500px;
    height: 270px;
    padding: 0 5px 5px 5px;
    /deep/ .video-js{
      width: 100%;
      height: 100%;
    }
  }
}
.web-container.minus{
  width:0px;
}
.index-handle {
  position: absolute;
  top: 300px;
  background: #1890ff;
  width: 48px;
  height: 48px;
  right: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  pointer-events: auto;
  z-index: 1001;
  text-align: center;
  font-size: 16px;
  border-radius: 4px 0 0 4px;

  i {
    color: rgb(255, 255, 255);
    font-size: 20px;
  }

  .text {
    color: #fff;
    font-size: 12px;
    line-height: 14px;
    text-align: center;
    width: 28px;
  }
}
</style>
